var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotStarted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.14 14.32C28.14 21.9526 21.9526 28.14 14.32 28.14C6.68742 28.14 0.5 21.9526 0.5 14.32C0.5 11.4369 1.38232 8.76132 2.89163 6.54676C5.29448 3.02113 9.28428 0.666277 13.8317 0.50846C13.9937 0.502836 14.1565 0.5 14.32 0.5C21.9526 0.5 28.14 6.68742 28.14 14.32Z",
    stroke: "#052941"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.1601,
    cy: 14.3203,
    r: 2.75385,
    fill: "#052941"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3198,
    cy: 14.3203,
    r: 2.75385,
    fill: "#052941"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.4799,
    cy: 14.3203,
    r: 2.75385,
    fill: "#052941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStarted);
export default __webpack_public_path__ + "static/media/NotStarted.286067b73924fedb7881ac3299c5e2f6.svg";
export { ForwardRef as ReactComponent };